import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    signal,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import {
    IconButtonComponent,
    ImageComponent,
    LiveStatusComponent,
    ProgressLoaderComponent,
} from '@interacta-shared/ui';
import { IconComponent } from '@interacta-shared/ui-icons';
import { IAttachment } from '@interacta/util-post';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-upload-attachment-item[attachment]',
    templateUrl: './upload-attachment-item.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ImageComponent,
        LiveStatusComponent,
        ProgressLoaderComponent,
        MatTooltip,
        IconButtonComponent,
        IconComponent,
        RouterLink,
        TranslatePipe,
    ],
})
export class UploadAttachmentItemComponent {
    readonly attachment = input.required<IAttachment>();
    readonly retryUpload = output();
    readonly cancelUpload = output();

    readonly hoverRow = signal(false);
    readonly hoverSuccessIcon = signal(false);
    readonly hoverError = signal(false);
}
